import { Store } from "~/bff/types/Store";
import { LOCALES } from "~/constants/i18n";
import { Nullable } from "~/types/general.types";
import { ProductRequestType } from "~/types/products-request-handler";

import { getStoreDetailsById } from "./get-store-details-by-id";
import { isCurrentStoreInCurrentLocation } from "./selected-store/is-current-store-in-current-location";
import { removePageFromUrl } from "./use-remove-page-from-url/helper";

export const checkAndSetStoreByLocation = (
  params: {
    locale: LOCALES;
    storeId: string | undefined;
    currentStore: Nullable<Store> | undefined;
    searchParams: URLSearchParams;
    pathname: string;
  },
  applyFunction: {
    setStore: (store: Store) => void;
    setShopFilter: (isShop: boolean) => void;
    setShopFilterSortingParam: (param: ProductRequestType) => void;
  },
): void => {
  const { locale, storeId, currentStore, searchParams, pathname } = params || {};
  const countryCode = locale.split("-")[1];

  if (currentStore?.id !== storeId && !!storeId) {
    getStoreDetailsById(locale, storeId).then((storeDetailsPageResponse) => {
      const storeDetailsById =
        storeDetailsPageResponse?.storeDetailsPage?.props?.storeDetailsById;
      if (
        storeDetailsById &&
        isCurrentStoreInCurrentLocation(countryCode, storeDetailsById)
      ) {
        applyFunction.setStore(storeDetailsById);
      } else {
        applyFunction?.setShopFilter(false);
        applyFunction?.setShopFilterSortingParam(ProductRequestType.AllProducts);
        removePageFromUrl(searchParams, pathname, true);
      }
    });
  }
};
